import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "../lib/constants";

export const WhatsAppButton = () => {
  return (
    <a
      href={SITE.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="hidden md:flex fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full wa-pulse" />
      <span className="wa-bounce relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] transition-colors shadow-[0_8px_30px_rgba(37,211,102,0.4)]">
        <MessageCircle className="w-6 h-6 text-white" />
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#0A0A0A] border border-[#222] text-white text-xs px-3 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
};
